module.exports = "file-power-point"